import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_WARRANTY = "listWarranties";
export const GET_DETAIL_WARRANTY = "detailWarranties";
export const SAVE_WARRANTY = "saveWarranties";
export const UPDATE_WARRANTY = "updateWarranties";
export const DELETE_WARRANTY = "deleteWarranties";
export const GET_DATA_SEARCH = "getDataSearchWarranties";
export const SET_DATA_SEARCH = "setDataSearchWarranties";
export const EXPORT_EXCEL_WARRANTY = "exportWarranty";

export const SET_LIST_WARRANTY = "setListWarranties";
export const SET_DETAIL_WARRANTY = "setDetailWarranties";
export const IMPORT_EXCEL_WARRANTY = "importWarranties";



const state = {
    warranties: [],
    warranty: {},
    dataSearch: []
};

const getters = {
    warranties(state) {
        return state.warranties;
    },
    warrantyDetail(state) {
        return state.warranty;
    },
    dataSearchWarranties(state) {
        return state.dataSearch;
    },
};

const actions = {
    [GET_LIST_WARRANTY](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_WARRANTY, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_WARRANTY, data);
                }
                resolve(data);
            });
        });
    },

    [GET_DATA_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_WARRANTY_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH, data.data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_WARRANTY](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_WARRANTY}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_WARRANTY, data);
                }
                resolve(data);
            });
        });
    },

    [SAVE_WARRANTY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_WARRANTY}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_WARRANTY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_WARRANTY}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_WARRANTY](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_WARRANTY}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [IMPORT_EXCEL_WARRANTY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.IMPORT_EXCEL_WARRANTY}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [EXPORT_EXCEL_WARRANTY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.download(`${API.EXPORT_EXCEL_WARRANTY}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_WARRANTY](state, data) {
        state.warranties =  data.data
    },
    [SET_DETAIL_WARRANTY](state, data) {
        state.warranty = data.data;
    },
    [SET_DATA_SEARCH](state, data) {
        state.dataSearch = data
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};